import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { blockParam } from '../../util/searchManual';

class ScrollToTopHOC extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location === prevProps.location) return
    // A ?block= link is asking for a particular offset, so topping the scroll
    // here would undo the jump ContentPane is about to make. Only ever reached
    // when the page is already mounted: a route change remounts it, so
    // componentDidUpdate never fires on the way in from elsewhere.
    if (blockParam(this.props.location.search) !== null) return
    window.scrollTo(0, 0)
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTopHOC)
